/**
 * Spanish headlines for the before-and-after patient stories.
 *
 * Most labels are plain patient names and need no translation — they take the
 * Spanish possessive form ("Transformación de Paula C."). Labels that are a
 * descriptive phrase in English are translated here, keyed by story slug, so
 * both the Spanish gallery page and the Spanish share-card generator read from
 * one source of truth.
 */

/** Slug -> Spanish label, for stories whose English label is a phrase. */
export const ES_STORY_LABELS: Record<string, string> = {
  "an-anonymous-virginia-bariatric-patient-2":
    "Un paciente anónimo de Virginia Bariatric",
  "an-anonymous-patient-who-got-her-groove-back-3":
    "Una paciente anónima que recuperó su energía",
  "an-anonymous-transformation-4": "Una transformación anónima",
  "another-amazing-anonymous-transformation-5":
    "Otra transformación anónima asombrosa",
  "an-anonymous-patient-s-one-year-change-6":
    "El cambio de un año de una paciente anónima",
  "amanda-g-another-view-14": "Amanda G., otra vista",
  "e-m-and-his-mom-19": "E.M. y su mamá",
  "a-halloween-costume-transformation-20":
    "Una transformación con disfraz de Halloween",
  "kristina-and-sean-22": "Kristina y Sean",
  "alfred-and-patricia-crews-12": "Alfred y Patricia Crews",
  "mr-g-27": "Sr. G",
  "an-anonymous-virginia-bariatric-weight-loss-surgery-patient-33":
    "Un paciente anónimo de cirugía de pérdida de peso en Virginia Bariatric",
  "an-anonymous-bariatric-surgery-patient-s-side-by-side-result-34":
    "Resultado lado a lado de un paciente anónimo de cirugía bariátrica",
  "an-anonymous-transformation-35":
    "La transformación de una paciente anónima",
};

/** True when the Spanish label is a phrase rather than a plain patient name. */
export function isEsPhraseLabel(label: string): boolean {
  return (
    /transformaci[oó]n|cambio|resultado|paciente|jornada/i.test(label) ||
    / y /.test(label) ||
    label.includes(",")
  );
}

/** Spanish label for a story: the translation when there is one, else the name. */
export function esStoryLabel(slug: string, label: string): string {
  return ES_STORY_LABELS[slug] ?? label;
}

/**
 * Spanish headline for a story card or gallery entry. Phrase labels get a
 * neutral suffix so the text never reads "…transformación de transformación".
 */
export function esStoryHeadline(slug: string, label: string): string {
  const esLabel = esStoryLabel(slug, label);
  if (isEsPhraseLabel(esLabel)) return `${esLabel} — resultados de pérdida de peso`;
  return `Transformación de ${esLabel}`;
}
